const PrePagoPendiente = {
    IdAbandonoCobranza: '',
    Deudas: [],
    IdTarjeta: ''
}

export default PrePagoPendiente